module.exports = __webpack_public_path__ + "img/charging-hub-definitive-private.6c4bb613.png";